export enum BillingoPartnerTaxType {
    FOREIGN = "FOREIGN",
    HAS_TAX_NUMBER = "HAS_TAX_NUMBER",
    NO_TAX_NUMBER = "NO_TAX_NUMBER"
}

export interface BillingoPartner {
    id: number;
    name: string;
    address: {
        country_code: string;
        post_code: string;
        city: string;
        address: string;
    };
    taxcode: string;
    phone: string;
    tax_type: BillingoPartnerTaxType; // Could be a union type if the values are fixed
    emails: string[];
}

export interface PostBillingoPartnerDto {
    name: string;
    address: {
        country_code: string;
        post_code: string;
        city: string;
        address: string;
    };
    phone: string;
    emails: string[];
}